module.exports = __webpack_public_path__ + "static/media/mandolin.d63a88e5.svg";